import { styled } from '@linaria/react';

export const ProductsListContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;

    @media (max-width: 768px) {
        padding: 0.75rem;
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
`;

export const ProductsHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.2rem;

    h2 {
        color: #333;
        margin: 0;
        font-size: 1.4rem;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 1rem;
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;

    p {
        color: #6c757d;
        font-size: 0.9rem;
    }
`;

export const LoadingSpinner = styled.div`
    width: 40px;
    height: 40px;
    border: 4px solid #e3e3e3;
    border-top: 4px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    text-align: center;

    h3 {
        color: #dc3545;
        margin-bottom: 1rem;
    }

    p {
        color: #6c757d;
        margin-bottom: 1.5rem;
    }
`;

export const RetryButton = styled.button`
    background: #dc3545;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 600;
    transition: background-color 0.3s;

    &:hover {
        background: #c82333;
    }
`;

export const EmptyState = styled.div`
    text-align: center;
    padding: 3rem;
    color: #6c757d;

    p {
        font-size: 0.9rem;
    }
`;

export const SearchSection = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1.2rem;

    @media (max-width: 768px) {
        flex-wrap: wrap;
        margin-bottom: 0.5rem;
    }
`;

export const SearchInputWrapper = styled.div`
    display: flex;
    gap: 0.4rem;
    flex: 1;

    @media (max-width: 768px) {
        flex: 1 1 auto;
        min-width: 0;
    }
`;

export const SearchInput = styled.input`
    flex: 1;
    padding: 0.5rem 0.8rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    font-size: 0.8rem;
    background: white;

    &:focus {
        outline: none;
        border-color: #6c757d;
        box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.1);
    }
`;

export const FilterToggleBtn = styled.button<{ $active?: boolean }>`
    padding: 0.5rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    background: white;
    cursor: pointer;
    color: #6c757d;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f8f9fa;
        border-color: #6c757d;
    }

    ${props => props.$active ? `
        background: #6c757d;
        color: white;
        border-color: #6c757d;
    ` : ''}

    svg {
        width: 16px;
        height: 16px;
    }
`;

export const SearchOptions = styled.div`
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const SearchOptionsContainer = styled.div`
    /* Container for search options */
`;

export const SearchFieldsSection = styled.div`
    /* Search fields section */
`;

export const SectionLabel = styled.label`
    display: block;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1rem;
    font-size: 0.8rem;
`;
export const CheckboxGroup = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 0.75rem;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const CheckboxLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    cursor: pointer;
    color: #495057;
    font-size: 0.75rem;

    input[type='checkbox'] {
        width: 16px;
        height: 16px;
        cursor: pointer;
    }

    span {
        -webkit-user-select: none;
        user-select: none;
    }

    &:hover {
        color: #333;
    }
`;

export const ProductsListView = styled.div`
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;

    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;

        &:hover {
            background: #a1a1a1;
        }
    }

    @media (max-width: 768px) {
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
`;

export const ListHeader = styled.div`
    display: grid;
    grid-template-columns: 40px 2fr 2fr 1.5fr 1fr 60px 0.7fr;
    background: rgb(238, 238, 238);
    border-bottom: 1px solid #dee2e6;
    flex-shrink: 0;

    @media (max-width: 768px) {
        display: none;
    }
`;

export const ListRowsContainer = styled.div`
    flex: 1;
    min-height: 0;
    overflow-y: auto;

    /* Custom scrollbar styling */
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 4px;

        &:hover {
            background: #a1a1a1;
        }
    }

    @media (max-width: 768px) {
        flex: 1;
        height: auto !important;
        min-height: 0;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
`;

export const HeaderCell = styled.div`
    padding: 0.6rem;
    font-weight: 600;
    color: #495057;
    font-size: 0.7rem;
    text-transform: uppercase;
    border-right: 1px solid #dee2e6;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;

    &.icon-header {
        text-align: center;
        padding: 0.4rem;
    }

    &:last-child {
        border-right: none;
        text-align: center;
    }

    @media (max-width: 768px) {
        display: none;
    }
`;

export const ListRow = styled.div<{ $clickable?: boolean; $inactive?: boolean }>`
    display: grid;
    grid-template-columns: 40px 2fr 2fr 1.5fr 1fr 60px 0.7fr;
    border-bottom: 1px solid #f1f3f4;
    transition: background-color 0.2s;
    cursor: pointer;

    ${props => props.$inactive ? `
        opacity: 0.55;
        background: #fafafa;
    ` : ''}

    &:hover {
        background: #f8f9fa;
        ${props => props.$inactive ? `opacity: 0.75;` : ''}
    }

    &:last-child {
        border-bottom: none;
    }

    @media (max-width: 768px) {
        grid-template-columns: 28px 1fr auto;
        grid-template-rows: auto auto;
        padding: 0.5rem 0;
        gap: 0 0.4rem;
        align-items: center;
    }
`;

export const ListCell = styled.div`
    padding: 0.6rem;
    color: #495057;
    border-right: 1px solid #f1f3f4;
    display: flex;
    align-items: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    min-width: 0;
    font-size: 0.75rem;

    &:last-child {
        border-right: none;
        justify-content: center;
    }

    &.icon-cell {
        justify-content: center;
        padding: 0.4rem;
        overflow: visible;

        img {
            width: 20px;
            height: 20px;
            min-width: 20px;
            min-height: 20px;
            display: block;
            flex-shrink: 0;
        }
    }

    &.type-cell {
        justify-content: center;
        padding: 0.4rem;
        overflow: visible;
    }

    &.product-name-cell {
        .product-name {
            font-weight: 600;
            color: #333;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 100%;
            font-size: 0.75rem;
        }
    }

    @media (max-width: 768px) {
        padding: 0.3rem;
        border-right: none;
        font-size: 0.7rem;

        /* Hide secondary columns on mobile */
        &.category-cell,
        &.cas-cell,
        &.type-cell {
            display: none;
        }

        &.icon-cell {
            padding: 0.2rem;
            grid-row: 1 / 3;
            align-self: center;

            img, svg {
                width: 16px;
                height: 16px;
                min-width: 16px;
                min-height: 16px;
                font-size: 14px;
            }
        }

        &.product-name-cell {
            grid-row: 1;
            grid-column: 2;
            padding-bottom: 0;
        }

        &.charterer-cell {
            grid-row: 2;
            grid-column: 2;
            padding-top: 0;
            font-size: 0.65rem;
            color: #6c757d;
        }

        &.status-cell {
            grid-row: 1 / 3;
            grid-column: 3;
            justify-content: flex-end;
            align-self: center;
            padding-right: 0.5rem;
        }
    }
`;

export const StatusBadge = styled.span<{ $active?: boolean }>`
    padding: 0.2rem 0.4rem;
    border-radius: 4px;
    font-size: 0.65rem;
    font-weight: 600;

    ${props => props.$active ? `
        background: #d4edda;
        color: #155724;
    ` : `
        background: #f8d7da;
        color: #721c24;
    `}
`;

export const LoadMoreContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
    flex-shrink: 0;

    @media (max-width: 768px) {
        gap: 8px;
        padding: 8px 0;
    }
`;

export const LoadMoreButton = styled.button<{ $disabled?: boolean }>`
    padding: 8px 24px;
    border: 1px solid #dee2e6;
    background: ${props => props.$disabled ? '#f8f9fa' : '#ffffff'};
    color: ${props => props.$disabled ? '#adb5bd' : '#495057'};
    border-radius: 4px;
    cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
    font-size: 0.875rem;
    transition: all 0.2s;

    &:hover:not(:disabled) {
        background: #e9ecef;
        border-color: #adb5bd;
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    @media (max-width: 768px) {
        padding: 6px 16px;
        font-size: 0.8rem;
    }
`;

export const LoadMoreInfo = styled.span`
    color: #6c757d;
    font-size: 0.8rem;

    @media (max-width: 768px) {
        font-size: 0.75rem;
    }
`;

export const SearchLoadingIndicator = styled.div`
    width: 20px;
    height: 20px;
    border: 2px solid #e3e3e3;
    border-top: 2px solid #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);

    @keyframes spin {
        0% { transform: translateY(-50%) rotate(0deg); }
        100% { transform: translateY(-50%) rotate(360deg); }
    }
`;

export const ActiveFilterContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.35rem 0.7rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    background: #fff;
    white-space: nowrap;
    font-size: 0.8rem;
    color: #6c757d;
`;

export const ActiveFilterLabel = styled.span`
    font-size: 0.8rem;
    color: #6c757d;
    user-select: none;
`;

export const FilterToggleButton = styled.button<{ $active?: boolean }>`
    background: none;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 0.55rem 0.7rem;
    cursor: pointer;
    font-size: 0.8rem;
    color: #6c757d;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    transition: all 0.2s;
    white-space: nowrap;

    &:hover {
        color: #495057;
        border-color: #adb5bd;
        background: #f8f9fa;
    }

    ${props => props.$active ? `
        color: #0066cc;
        border-color: #0066cc;
        background: #e7f1ff;
    ` : ''}

    svg {
        width: 14px;
        height: 14px;
    }

    @media (max-width: 768px) {
        display: none;
    }
`;

export const NewCategoryButton = styled.button`
    background-color: #4caf50;
    border: none;
    border-radius: 6px;
    padding: 0.55rem 0.7rem;
    cursor: pointer;
    font-size: 0.8rem;
    color: white;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    transition: all 0.2s;
    white-space: nowrap;

    &:hover {
        background-color: #388e3c;
    }

    svg {
        width: 14px;
        height: 14px;
    }

    @media (max-width: 768px) {
        display: none;
    }
`;

export const FilterPanel = styled.div`
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 1rem;
    margin-bottom: 1rem;
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
`;

export const FilterGroup = styled.div`
    flex: 1;
    min-width: 180px;
`;

export const FilterGroupTitle = styled.div`
    font-weight: 600;
    font-size: 0.8rem;
    margin-bottom: 0.5rem;
    color: #333;
`;

export const FilterCheckboxGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.35rem;

    label {
        display: flex;
        align-items: center;
        gap: 0.4rem;
        font-size: 0.8rem;
        cursor: pointer;
        color: #495057;

        &:hover {
            color: #0066cc;
        }

        input[type='checkbox'] {
            cursor: pointer;
        }
    }
`;

/** Wrapper for inline filter toggles — visible on desktop, hidden on mobile */
export const InlineFiltersRow = styled.div`
    display: contents;

    @media (max-width: 768px) {
        display: none;
    }
`;

/** Mobile-only filter toggle button with chevron */
export const MobileFilterToggle = styled.button<{ $active?: boolean }>`
    display: none;

    @media (max-width: 768px) {
        display: flex;
        align-items: center;
        gap: 0.25rem;
        background: none;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        padding: 0.55rem 0.5rem;
        cursor: pointer;
        color: #6c757d;
        transition: all 0.2s;
        flex-shrink: 0;

        &:hover {
            color: #495057;
            border-color: #adb5bd;
            background: #f8f9fa;
        }

        ${props => props.$active ? `
            color: #0066cc;
            border-color: #0066cc;
            background: #e7f1ff;
        ` : ''}

        svg {
            width: 16px;
            height: 16px;
        }

        .chevron {
            width: 18px;
            height: 18px;
            transition: transform 0.2s;

            ${props => props.$active ? `
                transform: rotate(180deg);
            ` : ''}
        }
    }
`;

/** Collapsible panel shown below search bar on mobile */
export const MobileFilterPanel = styled.div`
    display: none;

    @media (max-width: 768px) {
        display: flex;
        flex-direction: column;
        gap: 0.75rem;
        padding: 0.75rem;
        margin-bottom: 0.5rem;
        background: #f8f9fa;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        animation: slideDown 0.15s ease-out;

        /* Active/Inactive toggles side by side */
        .mobile-toggles-row {
            display: flex;
            gap: 0.75rem;
            flex-wrap: wrap;
        }

        /* Search In + Filter groups side by side */
        .mobile-filter-groups-row {
            display: flex;
            gap: 1rem;

            > * {
                flex: 1;
                min-width: 0;
            }
        }

        @keyframes slideDown {
            from {
                opacity: 0;
                transform: translateY(-8px);
            }
            to {
                opacity: 1;
                transform: translateY(0);
            }
        }
    }
`;